export default __webpack_public_path__ + "static/media/fonts/zoom.c61d116c.svg";